"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { sortOptions, type SortSlug } from "@/lib/sorting";

export function SortSelect({ value }: { value: SortSlug }) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return (
    <label className="flex items-center gap-3 text-[0.9375rem]">
      <span className="text-paper">Sort by</span>
      <select
        value={value}
        onChange={(event) => {
          const params = new URLSearchParams(searchParams);
          if (event.target.value === "featured") params.delete("sort");
          else params.set("sort", event.target.value);
          const query = params.toString();
          router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false });
        }}
        className="field w-auto py-2 pr-9"
      >
        {sortOptions.map((option) => (
          <option key={option.slug} value={option.slug}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
